import React from 'react';
import { useAuth } from '../../hooks/common/useAuth';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../constants/service/common/userPermissions';
import { SearchDictionaryWorkspace } from '../../views/searchDictionary/components/SearchDictionaryWorkspace';

export const SearchDictionaryContainer = (): React.JSX.Element => {
  const { can } = useAuth();
  const subject = PERMISSION_SUBJECTS.SEARCH_DICTIONARY;
  return (
    <SearchDictionaryWorkspace
      canRead={can(PERMISSION_ACTIONS.READ, subject)}
      canCreate={can(PERMISSION_ACTIONS.CREATE, subject)}
      canUpdate={can(PERMISSION_ACTIONS.UPDATE, subject)}
      canDelete={can(PERMISSION_ACTIONS.DELETE, subject)}
    />
  );
};
